var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27959"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27954"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9086",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27955"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Outline / Files /Upload"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.17 13.617H4.6a1.513 1.513 0 0 1-1.516-1.389 38.067 38.067 0 0 1-.114-4.94l-.133-.009-.125-.009-1.519-.112A1.285 1.285 0 0 1 .2 5.185 20.557 20.557 0 0 1 5.057.266a1.412 1.412 0 0 1 1.651 0 20.557 20.557 0 0 1 4.853 4.919 1.285 1.285 0 0 1-.989 1.973l-1.52.111-.127.009h-.006l-.125.009a37.911 37.911 0 0 1-.109 4.941 1.513 1.513 0 0 1-1.515 1.389zM5.882 1.557l-.542.389a14.81 14.81 0 0 0-3.62 3.717l1.1.081c.34.025.673.045.989.06a.766.766 0 0 1 .725.813 36.514 36.514 0 0 0 .065 5.47h2.56a36.4 36.4 0 0 0 .064-5.47.767.767 0 0 1 .73-.817c.316-.015.648-.035.988-.06l1.1-.081a14.79 14.79 0 0 0-3.62-3.717l-.542-.389z",
    transform: "rotate(90 7.4 13.422)",
    style: {
      fill: "#1bc47d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.53.765a.765.765 0 0 0-1.53 0V2.8a1.785 1.785 0 0 0 1.785 1.789h12.237A1.785 1.785 0 0 0 15.807 2.8V.765a.765.765 0 1 0-1.53 0V2.8a.255.255 0 0 1-.255.255H1.785A.255.255 0 0 1 1.53 2.8z",
    transform: "rotate(90 1.795 5.795)",
    style: {
      fill: "#8c8d99"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutColored);
export default __webpack_public_path__ + "static/media/logout-colored.6b2cbbc7e3e60d26f4202732648a0d45.svg";
export { ForwardRef as ReactComponent };